import { IconButton } from "@chakra-ui/react"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import { useState } from "react"

const CopyBlockLink = ({ onCopy, block }) => {
  const [linkCopied, setLinkCopied] = useState(false)

  return (
    <IconButton
      aria-label="Link to this block"
      icon={<Pathicon icon={linkCopied ? "check" : "link"} />}
      cursor="pointer"
      color="#666"
      size={18}
      onClick={() => {
        const currentURL = window.location.href

        // Get URL without hash
        const urlWithoutHash = currentURL.includes("#")
          ? currentURL.substring(0, currentURL.indexOf("#"))
          : currentURL

        // Write the full link (with hash) to clipboard
        navigator.clipboard.writeText(`${urlWithoutHash}#block-${block.id}`)

        // Update the URL hash when copying?
        // history.pushState(null, "", `#block-${block.id}`)

        // Show copied confirmation for 2 seconds
        setLinkCopied(true)
        setTimeout(() => setLinkCopied(false), 2000)

        if (onCopy) {
          onCopy()
        }
      }}
    />
  )
}

export default CopyBlockLink
